import { memo } from 'react';

import PropertyTableCheckboxCheckedIcon from '../icons/assets/PropertyTableCheckboxCheckedIcon';
import { BUILDER_MODE_V1_LAYOUT, BUILDER_MODE_V1_TOKENS } from '../constants';

const CHECKBOX_SIZE = 15;

interface PropertyTableCheckboxProperties {
  isChecked: boolean;
  onChange: () => void;
}

/** Figma node 75644:19088 — property table checkbox */
const PropertyTableCheckbox = memo(({ isChecked, onChange }: PropertyTableCheckboxProperties) => (
  <button
    type='button'
    aria-pressed={isChecked}
    onClick={(event) => {
      event.stopPropagation();
      onChange();
    }}
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: CHECKBOX_SIZE,
      height: CHECKBOX_SIZE,
      minWidth: CHECKBOX_SIZE,
      minHeight: CHECKBOX_SIZE,
      padding: 0,
      background: 'transparent',
      border: 'none',
      cursor: 'pointer',
      flexShrink: 0,
    }}
  >
    {isChecked ? (
      <PropertyTableCheckboxCheckedIcon size={CHECKBOX_SIZE} />
    ) : (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={CHECKBOX_SIZE}
        height={CHECKBOX_SIZE}
        viewBox='0 0 15 15'
        fill='none'
        aria-hidden
      >
        <rect
          x={0.5}
          y={0.5}
          width={14}
          height={14}
          rx={2.5}
          stroke={BUILDER_MODE_V1_LAYOUT.inputPanelHeaderMid}
          fill={BUILDER_MODE_V1_TOKENS.white}
        />
      </svg>
    )}
  </button>
));

PropertyTableCheckbox.displayName = 'PropertyTableCheckbox';

export default PropertyTableCheckbox;
